import type { paths } from '@orlikfy/api-interfaces';

export { AlertPriceDto, AlertTimeDto } from '@orlikfy/api-interfaces';

// GET /nearby-games/alerts
export const GET_NEARBY_GAMES_ALERTS_PATH = '/nearby-games/alerts' as const satisfies keyof paths;
type GetNearbyGamesAlertsOperation = paths[typeof GET_NEARBY_GAMES_ALERTS_PATH]['get'];
export type GetNearbyGamesAlertsResponse =
  GetNearbyGamesAlertsOperation['responses'][200]['content']['application/json'];

// PUT /nearby-games/alerts
export const UPDATE_NEARBY_GAMES_ALERTS_PATH = '/nearby-games/alerts' as const satisfies keyof paths;
type UpdateNearbyGamesAlertsOperation = paths[typeof UPDATE_NEARBY_GAMES_ALERTS_PATH]['put'];
export type UpdateNearbyGamesAlertsBody =
  UpdateNearbyGamesAlertsOperation['requestBody']['content']['application/json'];

// PATCH /nearby-games/alerts/location
export const UPDATE_NEARBY_GAMES_ALERTS_LOCATION_PATH = '/nearby-games/alerts/location' as const satisfies keyof paths;
type UpdateNearbyGamesAlertsLocationOperation = paths[typeof UPDATE_NEARBY_GAMES_ALERTS_LOCATION_PATH]['patch'];
export type UpdateNearbyGamesAlertsLocationBody =
  UpdateNearbyGamesAlertsLocationOperation['requestBody']['content']['application/json'];

// PATCH /nearby-games/alerts/enabled
export const UPDATE_NEARBY_GAMES_ALERTS_ENABLED_PATH = '/nearby-games/alerts/enabled' as const satisfies keyof paths;
type UpdateNearbyGamesAlertsEnabledOperation = paths[typeof UPDATE_NEARBY_GAMES_ALERTS_ENABLED_PATH]['patch'];
export type UpdateNearbyGamesAlertsEnabledBody =
  UpdateNearbyGamesAlertsEnabledOperation['requestBody']['content']['application/json'];

// PUT /user-meta/push-notification-enabled
export const UPDATE_PUSH_NOTIFICATION_ENABLED_PATH =
  '/user-meta/push-notification-enabled' as const satisfies keyof paths;
type UpdatePushNotificationEnabledOperation = paths[typeof UPDATE_PUSH_NOTIFICATION_ENABLED_PATH]['put'];
export type UpdatePushNotificationEnabledBody =
  UpdatePushNotificationEnabledOperation['requestBody']['content']['application/json'];
